import { environment } from '@environments/environment';

interface EventLeafMapping {
    classicLeaf: string;
    engageLeaf: string;
}

const EVENT_ROOT_LEAF = '';

const EVENT_LEAF_MAP: EventLeafMapping[] = [
    { classicLeaf: 'dashboard', engageLeaf: EVENT_ROOT_LEAF },
    { classicLeaf: 'invitations', engageLeaf: 'invitations' },
    { classicLeaf: 'ticketholders', engageLeaf: 'ticketholders' },
    { classicLeaf: 'tickets', engageLeaf: 'tickets' },
    { classicLeaf: 'communication', engageLeaf: 'communication' },
    { classicLeaf: 'website', engageLeaf: 'websites' },
];

const TOP_LEVEL_MAP: Record<string, string> = {
    events: 'events',
    addressbook: 'addressbook',
};

const EVENTS_SEGMENT = 'events';
const DEFAULT_EVENT_LEAF = 'dashboard';

function toPathSegments(classicUrl: string): string[] {
    const pathOnly = classicUrl.split('?')[0].split('#')[0];
    return pathOnly.split('/').filter(segment => segment.length > 0);
}

function toEngageEventPage(segments: string[]): string {
    const eventId = segments[1];
    const classicLeaf = segments[2] ?? DEFAULT_EVENT_LEAF;
    const eventRoot = `${EVENTS_SEGMENT}/${eventId}`;

    const mapping = EVENT_LEAF_MAP.find(leafMapping => leafMapping.classicLeaf === classicLeaf);
    if (!mapping || mapping.engageLeaf === EVENT_ROOT_LEAF) {
        return eventRoot;
    }

    return `${eventRoot}/${mapping.engageLeaf}`;
}

export function toEngagePage(classicUrl: string): string | undefined {
    const segments = toPathSegments(classicUrl);
    if (segments.length === 0) {
        return undefined;
    }

    if (segments[0] === EVENTS_SEGMENT && segments.length >= 2) {
        return toEngageEventPage(segments);
    }

    return TOP_LEVEL_MAP[segments[0]];
}

export function buildEngageBackdoorUrl(tenantId: string, page: string): string {
    return `${environment.engage.baseUrl}/login-backdoor?tenantid=${tenantId}&page=${encodeURIComponent(page)}`;
}

export function buildEngageUrlForClassicUrl(classicUrl: string, tenantId: string): string | undefined {
    const engagePage = toEngagePage(classicUrl);
    if (!engagePage) {
        return undefined;
    }

    return buildEngageBackdoorUrl(tenantId, engagePage);
}
